<script>
  import { HStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Button, Icon } from "./widget";
  import { navigate } from "../router";
  import { showNotImplemented } from "../dialog.js";

  const doit = () => navigate(`#/tablemap/${guid}`);

  export let guid;
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <section>
      <Spacer />
      <img src="/images/table.svg" alt="Plan de table" width="48px" />
      <span>Plan de table</span>
      <HStack>
        <Spacer />
        <button class="primary" on:click={showNotImplemented}>Créer</button>
        <Spacer />
      </HStack>
      <Spacer />
    </section>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={showNotImplemented}>
      <HStack alignment="center">
        <img src="/images/table.svg" alt="Plan de table" width="48px" />
        <span>Plan de table</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }
  @media (min-width: 481px) {
    article {
      padding: 1em;
      padding-top: 15%;
      background-color: white;
      width: auto;
      position: relative;
      border-radius: 50%;
      min-width: 120px;
    }
    section {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    span {
      margin-left: 0;
    }
  }
</style>
